import { BaseConfig } from './baseConfig';

const customConfig = {
  "apiRegistrationToken": "$2y$10$sR5J2rRZIxoJvWtQ4SXlFe2DpZajuYh0YSHLuAZmP0MO9Tk9auT0e",
  "apiHostGateway": "https://api.finalcad.cloud",
  "apiHostGatewayGlobal": "https://api.global.finalcad.cloud",
  "clarityProjectId": "sb8yufvs0y",
  "grpcGateway": "https://realtime-service-pusher.eu.finalcad.cloud",
  "pdfTronLicenseKey": "Finalcad:OEM:Finalcad One Web::B+:AMS(20270329):C9B62E23B68C0D5889994E616F5F0DF2D3F15F0435BACF4418D65AAAB6F5C7",
  "firebaseConfig": {
    "apiKey": "AIzaSyAEmhLO21A_KSfPNbh6QMQMpfco7TOkluQ",
    "authDomain": "finalcad-one-33577.firebaseapp.com",
    "databaseURL": "https://finalcad-one-33577.firebaseio.com",
    "projectId": "finalcad-one-33577",
    "storageBucket": "finalcad-one-33577.appspot.com",
    "messagingSenderId": "929576455949",
    "appId": "1:929576455949:web:e6c59f487055f2af236a44",
    "measurementId": "G-PJ815XCP3E"
  },
  "stripeCheckoutKey": "pk_live_51ILQ3mLfL2ThMUp8WHjPePbAgNrh6PFEnK7viRsWQjneswFRBnYPn1FgG1wI0B534ksvzGjnvnlAsIRlCCKOUNTn00pzflD6Nt",
  "sentry": {
    "environment": "production",
    "dsn": "https://9d76d2c8f44f4443a59a458eca6a1dca@o1003935.ingest.sentry.io/5973717"
  },
  "customerIo": {
    "siteId": "28a91593de24a5194848",
    "apiKey": "89431674b3de901f638e"
  },
  "gleap": {
    "appToken": "XEeED8r4vn9THhSQBfIPlUyUnmBhVZhL"
  },
  "googleMapsApiKey": "AIzaSyAEmhLO21A_KSfPNbh6QMQMpfco7TOkluQ",
  "auth0": {
    "domain": "orisha-construction.eu.auth0.com",
    "clientId": "fUvxqq2ytnSiOLOFJhlt15Ph57Ql1EtO",
    "audience": "https://auth0.api.finalcad.com",
    "tokenUrl": "https://orisha-construction.eu.auth0.com/oauth/token",
    "passwordRealmGrantType": "http://auth0.com/oauth/grant-type/password-realm",
    "refreshTokenGrantType": "refresh_token",
    "grantType": "http://auth0.com/oauth/grant-type/password-realm",
    "realm": "Username-Password-Authentication",
    "scope": "openid profile email offline_access"
  },
  "kolimmo": {
    "url": "https://app.kolimmo.com/pro/sites"
  }
};

const Config = {
  ...BaseConfig,
  ...customConfig,
};

export default Config;

